import {useEffect, useReducer} from 'react';

import {getActiveState} from 'client/framework';

/**
 * Re-renders the calling component whenever the legacy framework store emits 'change'.
 *
 * v2 dashboard tabs read Mandark stores passively: `getResource()` returns cached data but, unlike
 * old Flux-connected components, never subscribes React to the store. So on their own they wouldn't
 * update after a save or refetch — they'd show stale data. The old store-connected chrome re-rendered
 * on every store 'change'; this restores that for the v2 shell. Listener is removed on unmount.
 * Can be removed once all legacy store reads are replaced with Mandark-reactive queries. (etc useTeacherAssignments, useTeacherClassrooms, usePeopleRoster, useClassSettings etc...)
 */
export const useStoreChangePump = (): void => {
  const [, rerender] = useReducer((tick: number) => tick + 1, 0);
  useEffect(() => {
    const state = getActiveState();
    state.on('change', rerender);
    return () => {
      state.removeListener('change', rerender);
    };
  }, []);
};
